<!-- ============================ ARTWORK DETAIL ============================ -->
@if (detailWork) {
  <div class="ov" (click)="closeDetail()"></div>
  <div class="modal open" (click)="closeDetail()">
    <div class="mcard detail" (click)="$event.stopPropagation()">
      <button class="detail-x" type="button" (click)="closeDetail()" aria-label="Close">✕</button>

      <!-- Square cell + object-fit: contain. Artwork is NEVER cropped or stretched. -->
      <div class="detail-img">
        @if (detailTab === 'artist' && artist?.image) {
          <img [src]="artist!.image" [alt]="artist!.name" />
        } @else {
          <img [src]="detailWork.image" [alt]="detailWork.name" />
        }
      </div>

      <div class="detail-info">
        <!-- Same card, same footprint — the tab swaps what fills it, never its size. -->
        <!-- The prefetch usually settles before anyone looks, so an artist with no published site
             never gets offered a tab at all rather than one that bounces back. -->
        @if (showArtistTab && !artistUnavailable) {
          <div class="detail-tabs" role="tablist">
            <button type="button" role="tab" class="detail-tab"
                    [class.on]="detailTab === 'work'"
                    [attr.aria-selected]="detailTab === 'work'"
                    (click)="showTab('work')">The work</button>
            <button type="button" role="tab" class="detail-tab"
                    [class.on]="detailTab === 'artist'"
                    [attr.aria-selected]="detailTab === 'artist'"
                    (click)="showTab('artist')">The artist</button>
          </div>
        }

        @if (detailTab === 'artist') {
          @if (artistLoading) {
            <p class="detail-desc">Loading…</p>
          } @else if (artist) {
            <h3>{{ artist.name }}</h3>
            @if (artist.headline) { <div class="detail-series">{{ artist.headline }}</div> }
            @if (artist.location) { <div class="detail-meta"><span>{{ artist.location }}</span></div> }
            @if (artist.about) { <p class="detail-desc">{{ artist.about }}</p> }

            <!-- The whole story lives on their site; this panel only introduces them. -->
            @if (artist.slug) {
              <a class="detail-sitelink" [href]="'/profile/' + artist.slug" target="_blank" rel="noopener">
                See {{ artist.name }}’s website
              </a>
            }

            @if (canEnquire) {
              <button class="mbtn p" type="button" (click)="enquireAboutDetail()">
                Enquire about this piece
              </button>
            }
          }
        } @else {

        <h3>{{ detailWork.name }}</h3>
        @if (detailWork.artist) { <div class="detail-artist">{{ detailWork.artist }}</div> }
        @if (detailWork.series) { <div class="detail-series">{{ detailWork.series }}</div> }

        <div class="detail-meta">
          @if (detailWork.medium) { <span>{{ detailWork.medium }}</span> }
          @if (detailWork.dims) { <span>· {{ detailWork.dims }}</span> }
          @if (detailWork.price) {
            <span>· {{ detailWork.price | currency: currency : 'symbol' : '1.0-2' }}</span>
          }
        </div>

        <span class="detail-badge" [class.sold]="detailWork.sold">{{ statusOf(detailWork) }}</span>

        @if (detailWork.description) {
          <div class="detail-desc" [innerHTML]="detailWork.description"></div>
        }

        @if (canEnquire) {
          <button class="mbtn p" type="button" (click)="enquireAboutDetail()">
            Enquire about this piece
          </button>
        }
        }
      </div>
    </div>
  </div>
}

<!-- ============================ ENQUIRY ============================ -->
@if (enquiryOpen) {
  <div class="ov" (click)="closeEnquiry()"></div>
  <div class="modal open">
    <form class="mcard" (submit)="submit($event)">
      <h3>
        @if (enquiryWork) { Enquire — {{ enquiryWork.name }} }
        @else { Enquire — {{ contextTitle }} }
      </h3>

      <div class="mbody">
        <label for="dsenq-name">Your name</label>
        <input id="dsenq-name" name="name" placeholder="Jane Collector" required
               [(ngModel)]="draft.name" [ngModelOptions]="{standalone:true}" />

        <label for="dsenq-email">Email</label>
        <input id="dsenq-email" name="email" type="email" placeholder="jane@example.com" required
               [(ngModel)]="draft.email" [ngModelOptions]="{standalone:true}" />

        <label for="dsenq-msg">Message</label>
        <textarea id="dsenq-msg" name="message" rows="4" placeholder="I'd love to know more…" required
                  [(ngModel)]="draft.message" [ngModelOptions]="{standalone:true}"></textarea>

        @if (wasSent) { <p class="cnote">Thank you — your message has been sent.</p> }

        @if (error) {
          <p class="cnote cnote-err">
            {{ error }}
            <!-- Their typed message is not lost: offer the direct route instead. -->
            @if (mailtoFallback()) { <a [href]="mailtoFallback()">Send it by email instead</a> }
          </p>
        }
      </div>

      <div class="mact">
        <button type="button" class="mbtn g" (click)="closeEnquiry()">Cancel</button>
        <button type="submit" class="mbtn p" [disabled]="sending">
          {{ sending ? 'Sending…' : 'Send enquiry' }}
        </button>
      </div>
    </form>
  </div>
}
